import React, { Fragment, useState, useEffect } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import { H3, Btn, Breadcrumbs, H4 } from "../../AbstractElements";
import {getNotificationUsageReport} from "../../CommonURL";
import { getDataWithToken } from "../../Utils/restUtils";
import SearchList from "../../CommonElements/Search";
import Transparentspinner from "../Common/loader/Transparentspinner";
import IndustryFilter from "../Common/Filters/IndustryFilter";
import UserFilter from "../Common/Filters/UserFilter";
import { Link } from "react-router-dom";


const NotifiactionCreditUsage = () => {
  const style2 = { width: 60, fontSize: 13, padding: 3, marginRight: "10px" };
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };

  const [packData, setNotificationData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({});
  const [tempSearch, setTempSearch] = useState("");
   const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchResetKey, setSearchResetKey] = useState(0);
  const [isIndustry, setIsIndustry] = useState("");
  const [isUser, setIsUser] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dateRange, setDateRange] = useState([
    //   filters.start_date,
    //   filters.end_date,
  ]);
  const [startDate, endDate] = dateRange;
  
  const NotificationCreditColumns = [
    {
      name: <H4>Sl No</H4>,
      selector: (row) => row.Sl,
      sortable: true,
      width: "80px",
      center:true
    },
    {
      name: <H4>User Name</H4>,
      selector: (row) => (
      <Link
        to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${row.User_id}`}
      >
        {row.UserName}
      </Link>
    ),
      sortable: true,
      width: "150px",
    },
    {
      name: <H4>Industry</H4>,
      selector: (row) => row.Industry,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      name: <H4>Total Credit</H4>,
      selector: (row) => row.TotalCredit,
      sortable: true,
      width: "150px",
      wrap: true,
    },
     {
      name: <H4> Balance </H4>,
      selector: (row) => row.Balance,
      sortable: true,
      width: "150px",
      wrap: true,
    },
      {
      name: <H4>SMS Used</H4>,
      selector: (row) => row.SmsUsed,
      sortable: true,
      width: "150px",
    },
    {
      name: <H4>Whatsapp Used</H4>,
      selector: (row) => row.WhatsappUsed,
      sortable: true,
      width: "150px",
    },
      {
      name: <H4>SMS Used Count </H4>,
      selector: (row) => row.SmsUsedCount,
      sortable: true,
      width: "150px",
    },
    {
      name: <H4>Whatsapp Used Count</H4>,
      selector: (row) => row.WhatsappUsedCount,
      sortable: true,
      width: "150px",
    },
    
  
    
   
  ];

 const handleFilter = () => {
  const filters = {
    search: tempSearch,
    industry_type_id: isIndustry?.value || "",
    user_id: isUser?.value || "",
    start_date: startDate ? startDate.toISOString().split("T")[0] : "",
    end_date: endDate ? endDate.toISOString().split("T")[0] : "",
  };

  setAppliedFilters(filters);  
  setCurrentPage(1);

  fetchNotificationData(1, perPage, filters);
};
 

  useEffect(() => {
  fetchNotificationData();
}, []);

  const updateSearchKeyword = (keyword) => {
    setTempSearch(keyword);
  };

 const handlePageChange = (page) => {
  setCurrentPage(page);
  fetchNotificationData(page, perPage, appliedFilters);
};

const handlePerRowsChange = (newPerPage, page) => {
  setPerPage(newPerPage);
  fetchNotificationData(page, newPerPage, appliedFilters);
};
const fetchNotificationData = async (
  page = 1,
  size = perPage,
  filters = {}
) => {
  setLoading(true);

  try {
    const query = new URLSearchParams({
      page,
      page_length: size,
      search: filters.search || "",
      industry_type_id: filters.industry_type_id || "",
      user_id:filters.user_id || "",
      start_date: filters.start_date || "",
      end_date: filters.end_date || "",
    }).toString();

    const res = await getDataWithToken(
      `${getNotificationUsageReport}?${query}`
    );

    const formattedData = res.data.data.map((e, index) => ({
      Sl: (page - 1) * size + index + 1,
      Industry: e.industry_name,
      TotalCredit: e.total_credit,
      UserName: e.user_name,
      WhatsappUsedCount:e.whatsapp_count,
      SmsUsedCount:e.sms_count,
      SmsUsed: e.sms_used,
      WhatsappUsed: e.whatsapp_used,
      Balance: e.balance,
      User_id:e.user_id

    }));

    setNotificationData(formattedData);
    setTotalRows(res.data.total || 0); 
  } catch (err) {
    console.log(err);
  }

  setLoading(false);
};
const fetchExportData = async () => {
  const query = new URLSearchParams({
    export: "notification_usage_report",
    search: appliedFilters.search || "",
    industry_type_id: appliedFilters.industry_type_id || "",
    user_id: appliedFilters.user_id || "",
    start_date: appliedFilters.start_date || "",
    end_date: appliedFilters.end_date || "",
  }).toString();

  const res = await getDataWithToken(
    `${getNotificationUsageReport}?${query}`
  );

  return res?.data || [];
};
const exportPDF = async () => {
  setLoading(true);
  try {
    const data = await fetchExportData();

    const doc = new jsPDF();

    const rows = data.map((e, index) => [
      index + 1,
      e.user_name,
      e.industry_name,
      e.total_credit,
      e.sms_count,
      e.whatsapp_count,
      e.sms_used,
      e.whatsapp_used,
      e.balance,
    ]);

    autoTable(doc, {
      head: [[
        "Sl",
        "User",
        "Industry",
        "Total Credit",
        "SMS Count",
        "WhatsApp Count",
        "SMS Used",
        "WhatsApp Used",
        "Balance",
      ]],
      body: rows,
      styles: { fontSize: 8 },
    });

    doc.save("notification_credit_usage.pdf");
  } catch (err) {
    console.log(err);
  }
  setLoading(false);
};
const exportExcel = async () => {
  setLoading(true);
  try {
    const data = await fetchExportData();

    const formatted = data.map((e, index) => ({
      Sl: index + 1,
      User: e.user_name,
      Industry: e.industry_name,
      TotalCredit: e.total_credit,
      SmsUsedCount: e.sms_count,
      WhatsappUsedCount: e.whatsapp_count,
      SmsUsed: e.sms_used,
      WhatsappUsed: e.whatsapp_used,
      Balance: e.balance,
    }));

    const ws = XLSX.utils.json_to_sheet(formatted);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Notification Usage");

    XLSX.writeFile(wb, "notification_credit_usage.xlsx");
  } catch (err) {
    console.log(err);
  }
  setLoading(false);
};
  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs
        mainTitle="Notification Credit Usage "
        parent="Report"
        title="Notification Credit Usage"
      />
      <Card>
        <CardHeader className="d-flex justify-content-between align-items-center">
  <H3>Notifiaction Credit Usage Report</H3>

  <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
    <DropdownToggle className="btn btn-primary"  color="#fff" style={{ fontSize: '14px', zIndex: 1000 }}>
      Export <i className="icofont icofont-arrow-up"></i>
    </DropdownToggle>

    <DropdownMenu container="body">
      <DropdownItem onClick={exportExcel}>
        <i className="fa fa-file-excel-o me-2"></i> Excel
      </DropdownItem>

      <DropdownItem onClick={exportPDF}>
        <i className="fa fa-file-pdf-o me-2"></i> PDF
      </DropdownItem>
    </DropdownMenu>
  </Dropdown>
</CardHeader>
        <div
          style={{
            paddingLeft: "22px",
            marginRight: "22px",
            marginBottom: "-20px",
          }}
        >
        <div className="px-4 pb-2">
            <Row className="g-3 align-items-center">
              <Col sm="12" md="5" lg="3" className="pt-3">
                <SearchList
                  className="form-control"
                  key={searchResetKey}
                  updateSearchKeyword={updateSearchKeyword}
                  onEnter={handleFilter}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <IndustryFilter
                  IsIndustry={isIndustry}
                  setIsIndustry={setIsIndustry}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <UserFilter
                  IsUser={isUser}
                  setIsUser={setIsUser}
                />
              </Col>
               <Col sm="12" md="5" lg="3">
                <div style={{ position: "relative" }}>
                  <DatePicker
                    className="form-control digits w-100"
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => setDateRange(update)}
                    isClearable={!!(startDate || endDate)}
                    monthsShown={2}
                    calendarClassName="parallel-calendar"
                    placeholderText="Select Date Range"
                    dateFormat="dd-MM-yyyy"
                  />
                </div>
              </Col>
              <Col>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    float: "left",
                    gap: "10px",
                  }}
                >
                  <button
                    className="btn btn-primary mb-2 ms-2"
                    onClick={handleFilter}
                  >
                    Filter
                  </button>
                </div>
              </Col>
            </Row>
          </div>
          {/* <div style={{ float: "right" }}>
            <Link
              to={`${process.env.PUBLIC_URL}/configuration/account-add`}
              className="btn btn-primary"
            >
              {Add}
            </Link>
          </div> */}
          <div style={{ clear: "both" }}></div>
        </div>
        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
  columns={NotificationCreditColumns}
  data={packData}
  pagination
  paginationServer 
  paginationTotalRows={totalRows}   
  paginationDefaultPage={currentPage}
  onChangePage={handlePageChange}   
  onChangeRowsPerPage={handlePerRowsChange} 
  paginationRowsPerPageOptions={[10, 25, 50, 100]}
/>
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default NotifiactionCreditUsage;
